/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_Move_DownInputs */



/**
* | output |
* | --- |
* | "Move down" |
*
* @param {Media_Tab_Move_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_move_down = /** @type {((inputs?: Media_Tab_Move_DownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_Move_DownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Descendre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nach unten schieben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scendendo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Спуститесь вниз")
	if (locale === "es") return /** @type {LocalizedString} */ ("Baja")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向下")
	if (locale === "ja") return /** @type {LocalizedString} */ ("下へ移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नीचे की ओर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desça")
	return /** @type {LocalizedString} */ ("Move down")
});